module.exports = __webpack_public_path__ + "img/down.79f327dd.png";